export const enRtmBillingTranslations = {
  rtmBilling: {
    dashboard: {
      title: 'RTM Billing Dashboard',
      workspacePlaceholder: 'Workspace',
      clinicianPlaceholder: 'Clinician',
      billingMonthPlaceholder: 'Billing month',
      allClinicians: 'All clinicians',
      searchPlaceholder: 'Search patients',
      noAssignedClinician: 'No assigned clinician',
      error: 'Error loading billing data.',
      searchEmpty: 'No patients match your search.',
      copiedTooltip: 'Copied',
      copySummaryAriaLabel: 'Copy patient billing summary',
      copyRowAriaLabel: {
        education: 'Copy education summary',
        activity: 'Copy activity summary',
        monitoring: 'Copy monitoring summary',
      },
      filterAll: 'All',
      filterToBill: 'To Bill',
      filterDone: 'Done',
      markAsDone: 'Mark as done',
      markAllAsDone: 'Mark all as done',
      done: 'Done',
      tableHeader: {
        name: 'Name',
        dateOfService: 'Date of Service',
        dateOfServiceTooltip: 'Organized by most recent date of service.',
        education: 'Education',
        educationTooltip: 'The one-time education code appears once an event has been reported.',
        patientActivity: 'Patient activity',
        patientActivityTooltip: 'Codes appear after the end of a 30-day cycle or discharge.',
        clinicianMonitoringTime: 'Clinician monitoring time',
        clinicianMonitoringTimeTooltip:
          'Codes appear after the end of calendar month or discharge.',
        actions: 'Actions',
      },
    },
  },
};
